import { render, staticRenderFns } from "./cate-prop-modal.vue?vue&type=template&id=5c1ba496&"
import script from "./cate-prop-modal.vue?vue&type=script&lang=js&"
export * from "./cate-prop-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports